import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  ICONFERENCE,
  ICONFERENCE_ALL,
  ICONFERENCE_ALL_FILTER,
  ICONFERENCE_ARTICLE,
  ICONFERENCE_ARTICLE_ALL,
  ICONFERENCE_ARTICLE_LIST,
  ICONFERENCE_ARTICLE_PROOF,
  ICONFERENCE_ARTICLE_STEP,
  ICONFERENCE_CATEGORY_ALL,
  ICONFERENCE_CREATE,
  ICONFERENCE_MAGAZINE_ARTICLE,
} from '../constants/actionTypes'
import { initialState } from './initialState'

const iconferenceSelectors = (state: RootState) => prop(GLOBAL_STATE, state) as ReturnType<typeof initialState>

export const iconferenceSelector = createSelector(iconferenceSelectors, prop(ICONFERENCE))

export const iconferenceCreateSelector = createSelector(iconferenceSelectors, prop(ICONFERENCE_CREATE))

export const iconferenceAllSelector = createSelector(iconferenceSelectors, prop(ICONFERENCE_ALL))

export const iconferenceAllFilterSelector = createSelector(iconferenceSelectors, prop(ICONFERENCE_ALL_FILTER))

export const iconferenceArticleSelector = createSelector(iconferenceSelectors, prop(ICONFERENCE_ARTICLE))

export const iconferenceArticleListSelector = createSelector(iconferenceSelectors, prop(ICONFERENCE_ARTICLE_LIST))

export const iconferenceArticleAllSelector = createSelector(iconferenceSelectors, prop(ICONFERENCE_ARTICLE_ALL))

export const iconferenceMagazineArticleSelector = createSelector(
  iconferenceSelectors,
  prop(ICONFERENCE_MAGAZINE_ARTICLE)
)

export const iconferenceArticleStepSelector = createSelector(iconferenceSelectors, prop(ICONFERENCE_ARTICLE_STEP))

export const iconferenceArticleProofSelector = createSelector(iconferenceSelectors, prop(ICONFERENCE_ARTICLE_PROOF))

export const iconferenceCategoryAllSelector = createSelector(iconferenceSelectors, prop(ICONFERENCE_CATEGORY_ALL))
